<template>
  <span class="d-inline-block">
    <span ref="badgeTarget" class="d-inline-block">
      <b-badge variant="info">
        <i class="fa fa-cubes" /><span v-if="showLabel"> Bundle</span>
      </b-badge>
    </span>
    <b-popover
      v-if="ready"
      :target="getTarget"
      container="body"
      boundary="viewport"
      triggers="hover"
      placement="top"
      title="Bundle Of:"
    >
      <div v-for="(comp, idx) in components" :key="idx">
        <b>{{ comp.quantityToShip }}x</b> {{ comp.sku }}<span v-if="comp.name"> - {{ comp.name }}</span>
      </div>
    </b-popover>
  </span>
</template>

<script>
export default {
  name: 'BundleComponentsBadge',
  props: {
    components: {
      type: Array,
      default() {
        return [];
      }
    },
    showLabel: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ready: false
    };
  },
  mounted() {
    // The popover needs the badge element to exist before it can attach to it.
    this.ready = true;
  },
  methods: {
    getTarget() {
      return this.$refs.badgeTarget;
    }
  }
}
</script>
